"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geocodeMultiplePlaces = exports.geocodeSinglePoint = void 0;
const GoogleMapUtils_1 = require("./GoogleMapUtils");
const turf_1 = require("@turf/turf");
// In meters:
const geocodingSearchRadiusMinimum = 500;
const geocodingSearchRadiusMaximum = 8000;
const geocodeSinglePoint = (addressQueryString, options) => {
    return new Promise((resolve, reject) => {
        if (!google) {
            resolve(undefined);
        }
        const geocoder = new google.maps.Geocoder();
        const bounds = options.bbox
            ? new google.maps.LatLngBounds({ lat: options.bbox[0], lng: options.bbox[1] }, { lat: options.bbox[2], lng: options.bbox[3] })
            : undefined;
        geocoder.geocode({ address: addressQueryString, bounds }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results !== null) {
                const feature = (0, GoogleMapUtils_1.geojson)(results[0].geometry.location);
                if (feature) {
                    feature.properties.geocodingResultMetadata = {
                        formattedAddress: results[0].formatted_address,
                        precision: results[0].geometry.location_type,
                        types: results[0].types,
                        placeId: results[0].place_id
                    };
                    feature.properties.lastAction = 'geocoding';
                    feature.properties.geocodingQueryString = addressQueryString;
                }
                resolve(feature);
            }
            else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
                // No result
                resolve(undefined);
            }
            else {
                reject(`Geocoding failed for ${addressQueryString}`);
            }
        });
    });
};
exports.geocodeSinglePoint = geocodeSinglePoint;
const geocodeMultiplePlaces = (geocodingQueryString, options) => {
    return new Promise((resolve, reject) => {
        if (!options.map) {
            reject('Undefined map: Cannot use Google geocoder without Google maps');
            return;
        }
        if (!google || !options.bbox) {
            resolve(undefined);
            return;
        }
        const geocoder = new google.maps.places.PlacesService(options.map);
        const bounds = new google.maps.LatLngBounds({ lat: options.bbox[0], lng: options.bbox[1] }, { lat: options.bbox[2], lng: options.bbox[3] });
        const upperBound = (0, turf_1.point)([options.bbox[0], options.bbox[1]]);
        const lowerBound = (0, turf_1.point)([options.bbox[2], options.bbox[3]]);
        const viewportRadius = (0, turf_1.distance)(upperBound, lowerBound, { units: 'meters' }) / 2;
        const searchRadius = Math.min(Math.max(viewportRadius, geocodingSearchRadiusMinimum), geocodingSearchRadiusMaximum);
        geocoder.textSearch({
            query: geocodingQueryString,
            location: bounds.getCenter(),
            radius: searchRadius,
            language: options.language
        }, (results, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK && results !== null) {
                const places = results
                    .map(({ geometry, types, place_id, formatted_address, name, photos }) => {
                    const feature = (0, GoogleMapUtils_1.geojson)(geometry === null || geometry === void 0 ? void 0 : geometry.location);
                    if (!feature) {
                        return undefined;
                    }
                    feature.id = place_id;
                    feature.properties.placeData = {
                        types,
                        place_id,
                        formatted_address,
                        name,
                        photos
                    };
                    return feature;
                })
                    .filter((feature) => feature !== undefined);
                resolve(places);
            }
            else if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS ||
                status === google.maps.places.PlacesServiceStatus.NOT_FOUND) {
                // No result
                resolve([]);
            }
            else {
                reject(`Geocoding failed for ${geocodingQueryString}`);
            }
        });
    });
};
exports.geocodeMultiplePlaces = geocodeMultiplePlaces;
//# sourceMappingURL=GoogleGeocoder.js.map